import config from 'config/config'
import {
  classNames,
  sortableListDragSourceDragMarker,
  sortableListDropTargetDragMarker,
} from 'lib/utilities'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { Divider, Icon, Image, Table } from 'semantic-ui-react'

class AttachedMediaListItem extends React.Component {
  getIcon(medium) {
    if (medium && medium.content_type.match(/^image/))
      return <Image size="small" src={config.api_url + medium.small_url} />
    if (medium && medium.content_type === 'application/pdf')
      return <Icon name="file pdf outline" size="large" />
    return false
  }

  render() {
    const { medium, deleteMedium, index, dragMarker = {} } = this.props
    const { isDragging, connectDragSource, connectDropTarget } = this.props
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.index === index) {
      dragIndicator = dragMarker.position
    }
    return connectDragSource(
      connectDropTarget(
        <tr className={classNames([rowClass, dragIndicator])}>
          <Table.Cell
            className="draggable"
            content={<Icon {...config.icons.draggable} link />}
          />
          <Table.Cell>
            <div className="info">
              <span className="german tag">{medium.title_de}</span>
              <span className="french tag">{medium.title_fr}</span>
              <br />
              <Divider clearing className="compact" />
              <span className="unobtrusive">
                {this.getIcon(medium)} {medium.content_type}, {medium.file_size}
              </span>
            </div>
          </Table.Cell>
          <Table.Cell
            collapsing
            content={
              <Icon
                {...config.icons.unlink}
                onClick={() => {
                  deleteMedium(index)
                }}
                link
              />
            }
          />
        </tr>
      )
    )
  }
}

AttachedMediaListItem = DropTarget(
  'ProductMedium',
  sortableListDropTargetDragMarker,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(AttachedMediaListItem)
AttachedMediaListItem = DragSource(
  'ProductMedium',
  sortableListDragSourceDragMarker,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(AttachedMediaListItem)
export default AttachedMediaListItem



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/AttachedMediaListItem.jsx